module.exports = __webpack_public_path__ + "static/media/Traxsource.4da4d711.svg";